import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import { FaChevronDown } from 'react-icons/fa';

import * as Constants from '../../../../helpers/constants'
import { LIST_STATUSES, ANALYSIS_TABLE_DISPLAY_ORDER, TOP_RESULTS_TABLE_DISPLAY_ORDER } from '../../helpers/constants'
import * as Helper from '../../../../helpers/helper'
import ClickToCopy from '../../../widgets/copy_onclick'


const ResultTable = ({
  metrics: initialMetrics,
  resultsArray: initialResultsArray,
  lastVerifiedOn: initialLastVerifiedOn,
  status,
  service,
  domainStatsEV
}) => {
  const [metrics, setMetrics] = useState(initialMetrics)
  const [resultsArray, setResultsArray] = useState(initialResultsArray)
  const [lastVerifiedOn, setLastVerifiedOn] = useState(initialLastVerifiedOn)
  const [showDomainStats, setShowDomainStats] = useState(false);

  useEffect(() => {
    setMetrics(initialMetrics)
    setResultsArray(initialResultsArray)
    setLastVerifiedOn(initialLastVerifiedOn)
  }, [initialMetrics, initialResultsArray, initialLastVerifiedOn])

  const showTitleBasedOnStatus = () => {
    if (status === LIST_STATUSES.CANCELLED) {
      return (<span style={{ color: '#ff4c19' }}>Cancelled Result</span>)
    }
    return lastVerifiedOn ? 'Verified Result' : 'Analysis Result'
  }

  const isAnalysisMetricsExists = resultsArray.some(r => ANALYSIS_TABLE_DISPLAY_ORDER[service.NAME].indexOf(r) >= 0)

  return (
    <div className='analysis-table'>
      <div className='analysis-result-container'>
        <div className='m-0'>
          {showTitleBasedOnStatus()}
        </div>
        <table className='analysis-info-table table table-borderless table-sm'>
          <tbody>
            <tr className='analysis-table-tr'>
              <td className='valid-info-table'>
                <table className='table table-borderless'>
                  <tbody>
                    {resultsArray.map((result, index) => {
                      if (TOP_RESULTS_TABLE_DISPLAY_ORDER[service.NAME].includes(result)) {
                        return (
                          <tr key={index}>
                            <td className={classNames(`${result}-result`)}>
                              {Constants.RESULTS[result].display_name}
                            </td>
                            <td className='result-value'>
                              {Helper.getResultAsReqFormat(result, metrics[result])}
                            </td>
                          </tr>
                        )
                      }
                      return null
                    })}
                  </tbody>
                </table>
              </td>
              {isAnalysisMetricsExists && (
                <td className='analysis-tab-info'>
                  <table className='table table-borderless'>
                    <tbody>
                      {resultsArray.map((result, index) => {
                        if (ANALYSIS_TABLE_DISPLAY_ORDER[service.NAME].includes(result)) {
                          return (
                            <tr key={index}>
                              <td className={classNames(`${result}-result`)}>
                                {Constants.RESULTS[result].display_name}
                              </td>
                              <td className='result-value'>
                                {Helper.getResultAsReqFormat(result, metrics[result])}
                              </td>
                            </tr>
                          )
                        }
                        return null
                      })}
                    </tbody>
                  </table>
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </div>
      {
        domainStatsEV && domainStatsEV.count && (
          <div className='domain-stats-container mt-3'>
            <div
              colSpan='2'
              className='domain-stats-table-heading'
              onClick={() => setShowDomainStats(!showDomainStats)}
            >
              Top 10 Domain Stats
              <span className={`chevron-icon ${showDomainStats ? 'rotate-down' : 'rotate-left'}`}>
                <FaChevronDown />
              </span>
            </div>
            <table
              className='analysis-info-table table table-borderless table-sm'
            >
              {showDomainStats && (
                <tbody>
                  <tr className='analysis-table-tr'>
                    {(() => {
                      const entries = Object.entries(domainStatsEV.count);
                      const mid = Math.ceil(entries.length / 2);
                      const firstCol = entries.slice(0, mid);
                      const secondCol = entries.slice(mid);
                      return (
                        <>
                          {[firstCol, secondCol].map((column, colIndex) => (
                            <td
                              key={`col-${colIndex}`}
                              className={`domain-stats-column ${colIndex === 0 ? 'left-col' : 'right-col'}`}
                            >
                              <table className='table table-borderless table-sm'>
                                <tbody>
                                  {column.map(([domain, count], index) => (
                                    <tr key={`domain-${colIndex}-${index}`}>
                                      <td className='text-left'>  <ClickToCopy text={domain} /></td>
                                      <td className='text-right'>
                                        {count.value} ({count.percentage > 0 ? `${count.percentage}%` : count.percentage})
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>
                          ))}
                        </>
                      );
                    })()}
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        )}

    </div>
  );
}
export default ResultTable